import React from 'react';
import AsyncMarkAsSoldModal from 'Components/SellerCallToAction/AsyncMarkAsSoldModal';
import AsyncAskAdSoldModal from 'Components/SellerCallToAction/AsyncAskAdSoldModal';
import AsyncRemoveModal from 'Components/SellerCallToAction/AsyncRemoveModal';
import AsyncDeactivateModal from 'Components/SellerCallToAction/AsyncDeactivateModal';
import AsyncLearnMoreModal from 'Components/SellerCallToAction/AsyncLearnMoreModal';
import AsyncForbiddenModal from 'Components/SellerCallToAction/AsyncForbiddenModal/AsyncForbiddenModal';
import AsyncInsuranceDetails from 'Components/SellerCallToAction/AsyncInsuranceDetails';

export const SELLER_ACTIONS = {
    REMOVE: 'remove',
    REMOVE_RESERVED: 'removeReserved',
    ASK_FOR_SOLD: 'askForSold',
    MARK_AS_SOLD: 'markAsSold',
    MARK_AS_SOLD_RESERVED: 'markAsSoldReserved',
    LEARN_MORE: 'learnMore',
    EDIT_AD: 'editAd',
    LIMITS: 'limits',
    BOOST: 'boost',
    DEACTIVATE: 'deactivate',
    DEACTIVATE_RESERVED: 'deactivateReserved',
    REPUBLISH: 'replublish',
    FORBIDDEN: 'forbidden',
    DOWNLOAD_LEADS: 'downloadLeads',
    ADD_INSURANCE_DETAILS: 'addInsuranceDetails'
};

export const PROPS = {
    images: 'images',
    title: 'title',
    price: 'price',
    itemId: 'itemId',
    onClick: 'onClick',
    callback: 'callback',
    track: 'track',
    open: 'open',
    onAccept: 'onAccept',
    onDecline: 'onDecline',
    onSecondAction: 'onSecondAction',
    allowEdit: 'allowEdit',
    config: 'config',
    username: 'username',
    location: 'location',
    userId: 'userId',
    description: 'description',
    item: 'item',
    origin: 'origin'
};

const actionCollection = component => {
    const hash = {
        [SELLER_ACTIONS.MARK_AS_SOLD]: {
            props: [PROPS.images,
                PROPS.title,
                PROPS.price,
                PROPS.itemId,
                PROPS.callback,
                PROPS.onClick,
                PROPS.track],
            component: AsyncMarkAsSoldModal
        },
        [SELLER_ACTIONS.ASK_FOR_SOLD]: {
            props: [PROPS.open,
                PROPS.onAccept,
                PROPS.onDecline],
            component: AsyncAskAdSoldModal
        },
        [SELLER_ACTIONS.REMOVE]: {
            props: [PROPS.open,
                PROPS.itemId,
                PROPS.userId,
                PROPS.onAccept,
                PROPS.onDecline,
                PROPS.onError],
            component: AsyncRemoveModal
        },
        [SELLER_ACTIONS.LEARN_MORE]: {
            props: [PROPS.onClick,
                PROPS.onSecondAction,
                PROPS.allowEdit,
                PROPS.config,
                PROPS.username,
                PROPS.location],
            component: AsyncLearnMoreModal
        },
        [SELLER_ACTIONS.DEACTIVATE]: {
            props: [PROPS.open,
                PROPS.itemId,
                PROPS.onAccept,
                PROPS.onDecline],
            component: AsyncDeactivateModal
        },
        [SELLER_ACTIONS.FORBIDDEN]: {
            props: [PROPS.open,
                PROPS.description,
                PROPS.onAccept,
                PROPS.onDecline
            ],
            component: AsyncForbiddenModal
        },
        [SELLER_ACTIONS.ADD_INSURANCE_DETAILS]: {
            props: [PROPS.onClick,
                PROPS.onSecondAction,
                PROPS.item,
                PROPS.origin,
                PROPS.track],
            component: AsyncInsuranceDetails
        }
    };

    return component in hash ? hash[component] : null;
};

export const actionFactory = (action, props) => {
    const factoryComponent = actionCollection(action);

    if (!factoryComponent) {
        return null;
    }
    const componentProps = {};

    factoryComponent.props.forEach(p => {
        componentProps[p] = props[p];
    });

    return React.createElement(factoryComponent.component, componentProps);
};
